import React from "react";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import "./image-card.scss";

export type ImageCardProps = {
  backgroundImage: string;
  link: string;
  heading?: JSX.Element;
  logoImage?: string;
  logoImageAlt?: string;
  text: string;
  ctaText: string;
};

export function ImageCard({
  backgroundImage,
  link,
  heading,
  logoImage,
  logoImageAlt,
  text,
  ctaText,
}: ImageCardProps) {
  return (
    <div
      className="image-card"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <a href={link} target="_blank" rel="noreferrer">
        <div className="image-card__content">
          {heading ?? <></>}
          {logoImage && (
            <img src={logoImage} alt={logoImageAlt} className="logo" />
          )}
          <p>{text}</p>
          <Button variant="text" tabIndex={-1}>
            {ctaText} <ButtonArrow />
          </Button>
        </div>
      </a>
    </div>
  );
}
